import { Store, useStore as useTanstackStore } from "@tanstack/react-store";
import { defaultTimeZone, savedTimeZone } from "../utils/timeZones";

interface TimeZone {
  enabled: boolean;
  selected: string;
}

export interface IStore {
  timeZone: TimeZone;
}

const initialValue: IStore = {
  timeZone: {
    enabled: savedTimeZone?.enabled ?? false,
    selected: savedTimeZone?.selected ?? defaultTimeZone,
  },
};

const store = new Store<IStore>(initialValue);

// Fit for typescript 4.x.x version
function useStore<T>(selector: (state: IStore) => T): T {
  return useTanstackStore<IStore, T>(store, selector);
}

export { store, initialValue, useStore };
